"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterSignatureSSS = void 0;
const features_1 = require("../../features");
const constants_1 = require("../constants");
// Types
const types_1 = require("../../features/authoriser/types");
const types_2 = require("../../features/types");
// Events
const events_1 = require("../../features/events");
class AdapterSignatureSSS {
    constructor(authoriser, eventBus) {
        this.subscribers = [];
        this.processId = null;
        this.signatureId = null;
        this.challenge = types_1.ChallengeType.NONE;
        this.currentSubscriptions = [];
        this.isProcessStarted = () => this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED && this.signatureService.state.isStarted;
        this.getSignatureId = () => { var _a; return (_a = this.signatureId) !== null && _a !== void 0 ? _a : ''; };
        this.getCurrentState = () => this.stateMachine.getCurrentState();
        this.setIdleState = () => {
            this.stateMachine.setState({ state: types_2.SignatureStateEnum.IDLE });
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: undefined },
                state: types_2.SignatureStateEnum.IDLE,
                success: false,
            }, this.eventBus);
        };
        this.setChallengeLoadingState = () => {
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: this.getChallengeData() },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                type: 'loading',
                success: false,
            }, this.eventBus);
        };
        this.setChallengeState = () => {
            this.stateMachine.init({ state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED, type: this.challenge });
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: this.getChallengeData() },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                success: true,
            }, this.eventBus);
        };
        this.setChallengeRetryState = (status) => {
            (0, events_1.publishShowSignatureEvent)({
                challenge: {
                    data: this.getChallengeData(),
                    retryStatus: status,
                },
                state: types_2.SignatureStateEnum.AUTHENTICATION_REQUIRED,
                success: true,
            }, this.eventBus);
        };
        this.setChallengeFailedValidationState = () => {
            this.stateMachine.init({ state: types_2.SignatureStateEnum.TECHNICAL_ERROR });
            (0, events_1.publishShowSignatureEvent)({
                challenge: { data: this.getChallengeData() },
                state: types_2.SignatureStateEnum.TECHNICAL_ERROR,
                type: types_2.SignatureError.FAILED_VERIFICATION,
                success: false,
            }, this.eventBus);
        };
        this.setErrorState = (state, type = types_2.SignatureError.GENERIC) => {
            this.signatureService.fail(state === types_2.SignatureStateEnum.SIGNATURE_FAILED, type);
            this.stateMachine.onTransition({ state });
            (0, events_1.publishErrorSignatureEvent)({ state, type }, this.eventBus);
        };
        this.setCancelledState = () => {
            this.stateMachine.onTransition({ state: types_2.SignatureStateEnum.SIGNATURE_CANCELLED });
            (0, events_1.publishShowSignatureEvent)({
                state: types_2.SignatureStateEnum.SIGNATURE_CANCELLED,
                success: true,
                challenge: { data: types_1.ChallengeType.NONE },
            }, this.eventBus);
        };
        this.setCompletedState = () => {
            this.stateMachine.onTransition({ state: types_2.SignatureStateEnum.SIGNATURE_COMPLETED });
            (0, events_1.publishFinishSignatureEvent)({ state: types_2.SignatureStateEnum.SIGNATURE_COMPLETED }, this.eventBus);
        };
        this.initialize = (_a) => __awaiter(this, [_a], void 0, function* ({ challengeResponse, onCancel, onConfirm, onRetry, processId, originalRequest, url, }) {
            this.processId = processId;
            this.signatureId = challengeResponse.progressId;
            this.onCancel = onCancel;
            this.onConfirm = onConfirm;
            this.onRetry = onRetry;
            this.setChallengeLoadingState();
            this.signatureService.initializeAuthoriser(challengeResponse, originalRequest, url);
            this.subscribeToEvents();
        });
        this.subscribeToEvents = () => {
            this.currentSubscriptions.push(this.signatureService.onStateChange(this.handleStateChange), (0, events_1.subscribeValidateSignatureEvent)((credentials) => {
                if (!credentials) {
                    return this.retryChallenge();
                }
                this.validateCredentials(credentials);
            }, this.eventBus), (0, events_1.subscribeResentChallengeEvent)(this.handleRetryChallengeStatusChange, this.eventBus), (0, events_1.subscribeCancelSignatureEvent)(this.cancel, this.eventBus), (0, events_1.subscribeRetrySignatureEvent)(this.retry, this.eventBus), (0, events_1.subscribeResetSignatureEvent)(this.reset, this.eventBus));
        };
        this.unsubscribeFromEvents = () => {
            this.currentSubscriptions.forEach(unsubscriber => unsubscriber());
        };
        // eslint-disable-next-line complexity
        this.handleStateChange = (state) => {
            var _a, _b, _c;
            this.challenge = (_b = (_a = this.getChallengeData()) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : types_1.ChallengeType.NONE;
            if (state.isChallengeVerificationFailed) {
                this.setChallengeFailedValidationState();
                return;
            }
            if (state.isFailed) {
                this.handleError(state);
                return;
            }
            if (state.isChallengeLoading || state.isChallengeVerifying) {
                this.setChallengeLoadingState();
                return;
            }
            if (state.isFinishing) {
                return;
            }
            if (state.isReadyToFinish) {
                this.setConfirmingProcessState(true);
                (_c = this.onConfirm) === null || _c === void 0 ? void 0 : _c.call(this);
                return;
            }
            if (state.isStarted) {
                this.setChallengeState();
            }
        };
        this.retryChallenge = () => __awaiter(this, void 0, void 0, function* () {
            try {
                this.setChallengeRetryState(types_2.RetryStatuses.LOADING);
                return yield this.signatureService.retryChallenge();
            }
            catch (error) {
                return this.setErrorState(types_2.SignatureStateEnum.TECHNICAL_ERROR, types_2.SignatureError.GENERIC);
            }
        });
        this.handleRetryChallengeStatusChange = ({ success }) => {
            this.setChallengeRetryState(success ? types_2.RetryStatuses.SUCCESS : types_2.RetryStatuses.ERROR);
        };
        this.validateCredentials = (credentials) => __awaiter(this, void 0, void 0, function* () {
            if (!credentials) {
                throw Error('Credentials cannot be null');
            }
            try {
                yield this.signatureService.verifyChallenge(credentials);
            }
            catch (err) {
                const error = err;
                if (error.httpStatus === constants_1.STATUS_ERROR) {
                    this.setErrorState(types_2.SignatureStateEnum.TECHNICAL_ERROR, types_2.SignatureError.GENERIC);
                }
                else {
                    this.setErrorState(types_2.SignatureStateEnum.SIGNATURE_FAILED, types_2.SignatureError.GENERIC);
                }
            }
        });
        this.handleError = (state) => {
            this.stateMachine.init({ state: types_2.SignatureStateEnum.SIGNATURE_FAILED });
            let type;
            if (state.error === types_2.SignatureError.EXPIRED_SIGNATURE_KEY) {
                type = types_2.SignatureError.EXPIRED_SIGNATURE_KEY;
            }
            else if (state.isBlocked || state.isChallengeBlocked) {
                type = types_2.SignatureError.CONSECUTIVE_ERRORS;
            }
            else {
                type = types_2.SignatureError.GENERIC;
            }
            (0, events_1.publishErrorSignatureEvent)({
                state: types_2.SignatureStateEnum.SIGNATURE_FAILED,
                type,
            }, this.eventBus);
        };
        this.clearRequestInfo = () => {
            this.signatureId = null;
        };
        this.cancel = () => {
            var _a;
            if (this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.SIGNATURE_COMPLETED ||
                this.stateMachine.getCurrentState().state === types_2.SignatureStateEnum.IDLE) {
                return;
            }
            this.signatureService.reset();
            this.setCancelledState();
            (_a = this.onCancel) === null || _a === void 0 ? void 0 : _a.call(this);
            this.clearRequestInfo();
        };
        this.finishSuccessfully = () => {
            this.setCompletedState();
            this.clearRequestInfo();
        };
        this.retry = () => {
            var _a;
            this.clearAll();
            (_a = this.onRetry) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        this.reset = () => {
            this.setIdleState();
            this.clearAll();
        };
        if (!eventBus) {
            throw new Error('EventBus is required');
        }
        this.signatureService = authoriser;
        this.stateMachine = new features_1.StateMachine({ stateList: types_2.signatureStates, inititialState: { state: types_2.SignatureStateEnum.IDLE } });
        this.eventBus = eventBus;
    }
    isProcessConfirmable(processId) {
        return !!this.signatureId && processId === this.processId;
    }
    getChallengeData() {
        var _a;
        if (this.signatureService.state.isChallengeLoading) {
            return null;
        }
        return ((_a = this.signatureService.challenge) === null || _a === void 0 ? void 0 : _a.data) || null;
    }
    setConfirmingProcessState(isConfirming) {
        this.signatureService.updateState({ isFinishing: isConfirming });
    }
    onStateChange(callback) {
        this.subscribers.push(callback);
        this.stateMachine.setSubscribers(this.subscribers);
    }
    clearAll() {
        this.unsubscribeFromEvents();
        this.signatureService.reset();
        this.clearRequestInfo();
    }
}
exports.AdapterSignatureSSS = AdapterSignatureSSS;
//# sourceMappingURL=AdapterSignatureSSS.js.map